import { PureComponent } from "react";
import { connect } from "react-redux";

import { hasRequiredAccessLevel } from "utils/app.util";
import { getCurrentUserAppRolesFromState } from "app/app.selectors";

class AccessControl extends PureComponent {
  render() {
    const {
      children,
      accessLevel,
      noAccessContent,
      currentUserAppRoles,
    } = this.props;

    const currentUserHasRequiredAccessLevel = hasRequiredAccessLevel(
      accessLevel,
      currentUserAppRoles,
    );

    return currentUserHasRequiredAccessLevel ? children : noAccessContent;
  }
}

AccessControl.defaultProps = {
  noAccessContent: null,
};

export default connect(state => ({
  currentUserAppRoles: getCurrentUserAppRolesFromState(state),
}))(AccessControl);
